import { computed } from 'vue'
import { cn, useModalStack } from '@gat-ship/vue-components'
import {
  parseSettingsTab,
  settingsTabVariantClass,
  SETTINGS_TAB_BASE_CLASS,
  type SettingsItem
} from '../model/user-settings-tabs'

const KIND = 'user-settings'

/**
 * The user-settings modal's open-state + active-tab, sourced from the central
 * ordered stack (the `?modals=` codec owns the URL). Reaches the pure tab
 * decisions through this seam so the modal stays presentational.
 */
export function useSettingsTabs() {
  const stack = useModalStack()
  const entry = computed(() =>
    stack.entries.value.find((item) => item.kind === KIND)
  )

  const open = computed({
    get: () => entry.value != null,
    set: (value) => {
      if (!value) stack.close(KIND)
    }
  })

  // An invalid/absent tab falls back to general without closing the modal.
  const activeItem = computed<SettingsItem>({
    get: () => parseSettingsTab(entry.value?.params.tab) ?? 'general',
    set: (item) => {
      if (entry.value) stack.update(KIND, { tab: item })
    }
  })

  /** Mobile tab-bar item classes for the given tab value. */
  function tabClass(value: string) {
    return cn(
      SETTINGS_TAB_BASE_CLASS,
      settingsTabVariantClass(value, activeItem.value)
    )
  }

  return { open, activeItem, tabClass }
}
